import React from "react";
import { Badge } from "@mui/material";
import { School } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const StyledBadge = styled(Badge)(({ theme, small }) => ({
  "& .MuiBadge-badge": {
    height: small ? 15 : 25,
    width: small ? 15 : 25,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fcfcfc",
    backgroundColor: theme.palette.primary.main,
    zIndex: 1,

    // REMOVE MUI DEFAULT BEHAVIOR THAT CAUSES CLIPPING
    padding: 0,
    minWidth: 0,
  },
}));

const MentorBadge = ({ children, isSmall = false }) => {
  return (
    <StyledBadge
      small={isSmall ? 1 : 0}
      overlap="circular"
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      badgeContent={
        <School sx={{ fontSize: isSmall ? "0.65rem" : "1rem" }} />
      }
    >
      {children}
    </StyledBadge>
  );
};

export default MentorBadge;
